$(function() {

    // setupCookiesBarButton();
    // toggleCookiesBar();
    // includeExternalCodes();

    // updateCookiesFromComplianz();


});

let updateCookiesFromComplianz = () => {
    
    let complianzCookies = getCookiesGroup('cmplz');

    let analyticsCookies = complianzCookies['statistics'] == 'allow' ? true : false;
    let marketingCookies = complianzCookies['marketing'] == 'allow' ? true : false;

    if(analyticsCookies || marketingCookies) 
    {
        updateConsent(
            complianzCookies['marketing'] == 'allow' ? 'granted' : 'denied',
            complianzCookies['statistics'] == 'allow' ? 'granted' : 'denied'
        );


        let cookies = [
            ['showBar', false],
            ['technic', true],
            ['analytics', analyticsCookies],
            ['marketing', marketingCookies]
        ];

        setCookiesGroup(cookies, 'cookiesBar', (3600 * 24) * 30);

        
        toggleCookiesBar();

    } 

}


function setupCookiesBarButton() {

    $('a.cookies-button').click(function() {
        var optionSelected = $(this).attr('data-cookiesOption')
        cookiesFormSubmited(optionSelected);
    });

}

function cookiesFormSubmited(option) {

    if (option == "acceptAll") 
    { 
        var cookies = [
            ['showBar', false],
            ['technic', true],
            ['analytics', true],
            ['marketing', true]
        ];

        updateConsent('granted', 'granted');
        
        var expiration = 'infinite';
    } 
    else if (option == "dennyAll") 
    {
        var cookies = [
            ['showBar', false],
            ['technic', true],
            ['analytics', false],
            ['marketing', false]
        ];

        updateConsent('denied', 'denied');
        
        var expiration = (3600 * 24) * 30;

    } 
    else if (option == "saveSettings") 
    {
        var analytics = $('input[name="analytics"]:checked').length > 0 ? 
                            $('input[name="analytics"]:checked').val() : 
                            $('input[name="analytics"]').val();

        var marketing = $('input[name="marketing"]:checked').length > 0 ? 
                                $('input[name="marketing"]:checked').val() : 
                                $('input[name="marketing"]').val();

        var cookies = [
            ['showBar', false],
            ['technic', true],
            ['analytics', analytics],
            ['marketing', marketing]
        ];


        var adStorage = marketing == '1' ? 'granted' : 'denied';
        var analyticsStorage = analytics == '1' ? 'granted' : 'denied';

        updateConsent(adStorage, analyticsStorage);

        var expiration = (3600 * 24) * 30;
    }

    setCookiesGroup(cookies, 'cookiesBar', expiration);

    toggleCookiesBar();
}

function toggleCookiesBar() {

    if(getCookiesGroup('cookiesBar')['showBar']) {
        $('#cookiesBar').hide();
    } else {
        $('#cookiesBar').show();
    }

}

function getMarketingCookie() {
    return getCookiesGroup('cookiesBar')['marketing'];
}

/* function includeExternalCodes() {

//     cookies = getCookiesGroup('cookiesBar');

//     if(cookies['analytics']) 
//     {
//         if(typeof includeGTMCode === "function"){
//             includeGTMCode();
//         }
//         if(typeof includeFBPixelCode === "function"){
//             includeFBPixelCode();
//         }
//         if(typeof includeGACode === "function"){
//             includeGACode();
//         }
//     }

//     if(cookies['marketing']) 
//     {
//         if(typeof includeSklikRemarketingCode === "function"){
//             includeSklikRemarketingCode();
//         }
//         if(typeof includeGoogleRemarketingCode === "function"){
//             includeGoogleRemarketingCode();
//         }
//         if(typeof includeAdwordsCode === "function"){
//             includeAdwordsCode();
//         }
//     }

// }
*/





//Cookies manipulation
function setCookiesGroup(cookies, groupName, expiration) {
   
    for (var i = 0; i < cookies.length; i++) {
        cookieName = groupName + "_" + cookies[i][0];
        cookieValue = cookies[i][1];

        setCookie(cookieName, cookieValue, expiration);
    }
}

function getCookiesGroup(groupName) {

    cookies = getAllCookies();

    groupName = groupName + '_';
    cookiesGroup = {};

    for (var i = 0; i < cookies.length; i++) {
        
        cookie = cookies[i];

        cookieName = cookie[0];
        if(cookieName.includes(groupName)) {   

            cookie = [
                ,
                cookie[1]
            ];

            cookiesGroup[cookieName.split("_")[1]] = cookie[1];
        }
    }

    return cookiesGroup;
}

function getAllCookies() {

    rawCookies = document.cookie.split(';');
    cookies = [];
    for (var i = 0; i < rawCookies.length; i++) {
        rawCookie = rawCookies[i];

        readyCookie = rawCookie.split('=');
        cookies.push(readyCookie);
    }

    return cookies;
}


function setCookie(name, value, seconds) {
    
    var d = new Date;

    if(seconds != "infinite") {
        d.setTime(d.getTime() + 1000 * seconds);
    } else {
        d.setTime(d.getTime() + (((1000 * 3600) * 24) * 365) * 100);
    }
    
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function deleteCookie(name) { 
    setCookie(name, '', -1); 
}